import DownloadApps from '@/components/downloadApps'
import LayoutWithNavigation from '@/components/layoutWithNavigation'
import PageHeader from '@/components/pageHeader'
import Picture from '@/components/picture'
import { appList, STRINGS } from '@/constants/agriFinance'

export async function getStaticProps() {
  return {
    props: {
      title: STRINGS.PAGE_TITLE,
      description: STRINGS.PAGE_DESCRIPTION,
    },
  }
}

const AgriculturalFinanceCreditInsurance = () => (
  <LayoutWithNavigation>
    <section className="px-6 my-4 max-w-7xl m-auto">
      <PageHeader
        heading={STRINGS.PAGE_HEADING}
        subHeading={STRINGS.SUB_HEADING}
      />
      <section className="flex md:flex-row flex-col">
        <div className="md:flex-1">
          <p className="whitespace-pre-wrap mb-2.5 text-footer-grey text-base font-natosans-light">
            {STRINGS.DESCRIPTION}
          </p>
          <h2 className="text-[#6bb51e] md:text-3xl text-xl leading-[1.4] my-2.5">
            {STRINGS.SECOND_SUBHEADING}
          </h2>
          <p className="whitespace-pre-wrap mb-2.5 mt-4 text-footer-grey text-base font-natosans-light">
            {STRINGS.INSURANCE_DESCRIPTION}
          </p>
          <div className="py-2.5">
            <DownloadApps apps={appList} />
          </div>
        </div>
        <div className="md:w-1/3 md:px-4 md:py-0 py-2.5">
          <Picture
            image="/assets/images/agri-finance/sapling"
            imageAlt="farmer sowing a sapling"
            loading="eager"
            imageStyle="w-full"
          />
        </div>
      </section>
    </section>
  </LayoutWithNavigation>
)

export default AgriculturalFinanceCreditInsurance
